import { render } from "./BlackListe.vue?vue&type=template&id=67882c9f&scoped=true"
import script from "./BlackListe.vue?vue&type=script&lang=js"
export * from "./BlackListe.vue?vue&type=script&lang=js"

import "./BlackListe.vue?vue&type=style&index=0&id=67882c9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67882c9f"]])

export default __exports__